module.exports = __webpack_public_path__ + "static/img/streamMedia-whyneed-img2.b2cfbc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/streamMedia-whyneed-img2.png
// module id = 1095
// module chunks = 1